import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { addThousandsSeparators } from 'utils/helper';
import { CONTACT_CASH_KEY, useSendContactFormMutation } from 'redux/apis/dataSending';
import visitData from 'utils/gaMetrics/getGaMetrics';
import { getPersonCountry } from 'utils/pipedrive/pipedriveHelper';
import { budget as budgetData, marks } from './data';

export default ({
  className,
  isBudgetSlider,
  type,
  extraDescription,
  ...restProps
}) => {
  const [sendForm, { isLoading, isError }] = useSendContactFormMutation({ fixedCacheKey: CONTACT_CASH_KEY });
  const [isButtonDisabled, setButtonState] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const {
    register,
    handleSubmit,
    reset,
    getValues,
    formState: { dirtyFields },
  } = useForm();
  const [budget, setBudget] = useState(addThousandsSeparators(budgetData.min));
  const [selectedFiles, setFiles] = useState([]);
  const sliderOptions = {
    ...budgetData,
    defaultValue: budgetData.min,
    step: 20000,
    onChange: (event, value) => setBudget(addThousandsSeparators(value)),
    marks,
  };

  const submitHandler = handleSubmit(async (values, event) => {
    event.preventDefault();
    setButtonState(true);

    const sourceMetrics = visitData();

    const attachments = selectedFiles.map((file) => file.signedUrl);

    const personCountry = await getPersonCountry();

    if (typeof personCountry !== 'undefined') {
      const { data } = await sendForm({
        ...values,
        attachments,
        projectBudget: budget || '',
        description: extraDescription ? `${values.description} ${extraDescription}` : values.description,
        source: sourceMetrics?.source,
        medium: sourceMetrics?.medium,
        city: personCountry?.city,
        clientCityRegion: `${personCountry?.city}, ${personCountry?.region}`,
        clientCountry: personCountry?.country_name,
      });

      if (data.isSuccess) {
        setIsSuccess(data.isSuccess);
        setButtonState(false);
        setFiles([]);
        setBudget(addThousandsSeparators(budgetData.min));
        reset({
          name: '',
          email: '',
          description: '',
          phone: '',
        });
      }
    }
  });

  const isValid = () => {
    const {
      description,
      email,
    } = getValues();

    return !!description && !!email;
  };

  return {
    type,
    register,
    submitHandler,
    dirtyFields,
    sliderOptions,
    budget,
    selectedFiles,
    setFiles,
    isBudgetSlider,
    isValid,
    contactFormError: isError,
    isDataSubmitted: isSuccess,
    isLoading,
    className,
    isButtonDisabled,
    ...restProps,
  };
};
